import apiSlice from './apiSlice';

export const { useComponentSeasonQuery } = apiSlice;
export { default as componentSeasonSelectors } from './selectors';
